module.exports = __webpack_public_path__ + "media/images/front/bg_top_events-486991bc83ab9176ae757d0fec992463.jpg";